export default __webpack_public_path__ + "static/media/GUARDIANS-TOKEN-SHIELD-LOGO.72992168.png";